module.exports = __webpack_public_path__ + "files/2418db91905ed032bf3a30ee72dd6a1a.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600.woff
 ** module id = 952
 ** module chunks = 0
 **/